import DatePreferencePicker from './common/DatePreferencePicker';
import InfoNotice from './common/InfoNotice';

interface StepScheduleProps {
  value: string | null;
  onChange: (val: string) => void;
}

export default function StepSchedule({ value, onChange }: StepScheduleProps) {
  return (
    <div className="space-y-4">
      <DatePreferencePicker value={value} onChange={onChange} />

      <InfoNotice title="방문 일정 안내" delay={0.15}>
        예복샵 상담은 평균 1~2시간 소요되며, 주말은 예약이 빡빡할 수 있어요.
        평일 오후나 휴무일을 활용하시면 여유롭게 둘러보실 수 있어요.
      </InfoNotice>
    </div>
  );
}
